export function runtimeParameters(da) {
  return (da && Array.isArray(da.runtime_parameters)) ? da.runtime_parameters : []
}

export function runtimeParametersNote(da) {
  const params = runtimeParameters(da)
  if (!params.length) return ''
  return `${da.name} needs runtime parameters (${params.map((p) => `{${p}}`).join(', ')}) that a workflow can't supply, so it can't go on the canvas.`
}
